import script from "./LoadingScreen.vue?vue&type=script&lang=ts&setup=true"
export * from "./LoadingScreen.vue?vue&type=script&lang=ts&setup=true"

import "./LoadingScreen.vue?vue&type=style&index=0&id=808fb34a&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-808fb34a"]])

export default __exports__